module.exports = __webpack_public_path__ + "img/contribution.a2fc14b3.png";